import { render, staticRenderFns } from "./IconPaymentSEPA.vue?vue&type=template&id=10515878&scoped=true"
import script from "./IconPaymentSEPA.vue?vue&type=script&lang=js"
export * from "./IconPaymentSEPA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10515878",
  null
  
)

export default component.exports